module.exports = __webpack_public_path__ + "jams-157830b1.webp";